import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const RefundPolicyPage = () => {
  const { theme } = useTheme();
  return (
    <>
      <Helmet><title>Refund Policy | BookMyAudition</title></Helmet>
      <div className="refund-policy-page" style={{ minHeight: '70vh', padding: '60px 0', backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc', color: theme === 'dark' ? '#f8fafc' : '#111' }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4">Refund Policy</h1>
              <p className="mb-5">Clear and transparent rules regarding cancellations and refunds.</p>
              <div className="coming-soon-box p-5 rounded-4 shadow-sm" style={{ backgroundColor: theme === 'dark' ? '#111116' : '#fff', border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}` }}>
                <div className="d-inline-block mb-3 px-3 py-1 rounded-pill" style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)', color: '#10b981', fontSize: '0.85rem', fontWeight: '600' }}>PAYMENTS</div>
                <h3>Coming Soon</h3>
                <p className="text-muted">We are detailing our refund process for workshops and premium subscriptions. Coming very soon.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default RefundPolicyPage;